import { IRegistration } from './Registration';
import { ICheckin } from './Checkin';

export interface IParticipantLocation {
  lat?: number;
  lng?: number;
  geocodedAt?: string | Date;
  geocodeKey?: string;
}

export interface IBaseParticipant {
  age: number;
  checkedIn?: string;
  city: string;
  country: string;
  dateOfBirth?: string | Date;
  discounted?: boolean;
  email: string;
  firstName: string;
  gender: string;
  lastName: string;
  phoneNumber: string;
  sportsGroupMember?: boolean;
  sportsGroupName?: string;
  onlineSignup?: boolean;
}

export interface IParticipant extends IBaseParticipant {
  id: string;
  ownerUserId?: string | null;
  location?: IParticipantLocation;
  createdAt?: string | Date;
  updatedAt?: string | Date;
}

export interface IEnrichedParticipant extends IParticipant {
  registration?: IRegistration;
  checkin?: ICheckin;
}

export enum EParticipantFilters {
  query = 'query',
  competition = 'competition',
  distance = 'distance',
  checkedIn = 'checkedIn',
  registeredFrom = 'registeredFrom',
  registeredTo = 'registeredTo',
  edition = 'edition',
  ownerUserId = 'ownerUserId',
}

/** Scalar string filters, multi-select id lists, or cleared (`null`). */
export type ParticipantFilterValue = string | string[] | null;

/** Save payload. Age is derived from date of birth and is not stored. */
export type IFormParticipant = Omit<IBaseParticipant, 'age'> & {
  dateOfBirth?: Date;
};

export type ParticipantsTableLayout = 'admin' | 'my';

